const EDITOR_VALID_URL = /^\/forms\/\d+\/editor\/([0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12})/;
const EDITOR_SETTINGS_VALID_URL = /^\/forms\/\d+\/editor\/([0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12})\/edit\/options/;
const EDITOR_AUTOMATION_VALID_URL = /^\/forms\/\d+\/editor\/([0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12})\/edit\/automation/;
const EDITOR_PAYMENT_FIELD_URL = /^\/forms\/\d+\/editor\/([0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12})\/edit\/form\/field\/0-0%2Fpayment_link/;
const INSIGHTS_VALID_URL = /^\/forms\/\d+\/([0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12})/;
const CREATE_FORM_URL = /^\/forms\/\d+(\/|(\/type\/?))?$/;
const TEMPLATES_URL = /^\/forms\/\d+(\/|(\/templates\/?))?$/;
const DASHBOARD_VALID_URL = /^\/forms\/\d+(\/(manage|analyze|views\/(all_forms|forms_with_submissions|published_forms|non_hubspot_forms|\d+)))?\/?$/;
const DASHBOARD_MANAGE_VALID_URL = /^\/forms\/\d+(\/(manage|views\/(all_forms|forms_with_submissions|published_forms|non_hubspot_forms|\d+)))?\/?$/;
const COMPARISON_URL = /\/forms\/\d+\/compare/;
const UUID_MATCHER = /([0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12})/g;
const PORTAL_MATCHER = /^\/forms\/(\d+)/;
const LOCAL_HOST = /local.(hubspot|hubspotqa).com/;
export function isEditorUrl(url = '') {
  return EDITOR_VALID_URL.test(url);
}
export const isEditorSettingsUrl = (url = '') => EDITOR_SETTINGS_VALID_URL.test(url);
export function getFormGUID(url = '') {
  var _url$match;
  return (_url$match = url.match(UUID_MATCHER)) === null || _url$match === void 0 ? void 0 : _url$match[0];
}
export const isInsightsValidUrl = (url = '') => INSIGHTS_VALID_URL.test(url);
export function getPortalId(url = '') {
  var _url$match2;
  return (_url$match2 = url.match(PORTAL_MATCHER)) === null || _url$match2 === void 0 ? void 0 : _url$match2[1];
}
export const getSubmissionId = (url = '') => {
  var _url$match3;
  return (_url$match3 = url.match(UUID_MATCHER)) === null || _url$match3 === void 0 ? void 0 : _url$match3[1];
};
export function isValidDashboardUrl(url = '') {
  return DASHBOARD_VALID_URL.test(url);
}
export function isValidDashboardManageTabUrl(url = '') {
  return DASHBOARD_MANAGE_VALID_URL.test(url);
}
export function isCreateFormUrl(url = '') {
  return CREATE_FORM_URL.test(url);
}
export const isTemplatesUrl = (url = '') => TEMPLATES_URL.test(url);
export const isAutomationUrl = (url = '') => EDITOR_AUTOMATION_VALID_URL.test(url);
export const isPaymentFieldUrl = (url = '') => EDITOR_PAYMENT_FIELD_URL.test(url);
export const isComparisonUrl = (url = '') => COMPARISON_URL.test(url);
export const isLocalHost = (hostname = '') => LOCAL_HOST.test(hostname);